// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"3727b762","137":"1dbab8f9","143":"7cbfc79b","196":"c09e803f","333":"0da062fd","629":"7e38b1f4","724":"e7678b91","892":"3199b1bd","950":"37a6255e"}[chunkId] + ".chunk.js";
};